import { Role } from '@/types/auth';

export interface TourStepInfo {
  targetId: string;
  title: string;
  content: string;
  placement: 'top' | 'bottom' | 'left' | 'right';
}

export const TOUR_STEPS: Record<Role, TourStepInfo[]> = {
  [Role.ADMIN]: [
    { targetId: 'nav-dashboard', title: 'Dashboard Geral', content: 'Visão completa das métricas da clínica em tempo real.', placement: 'right' },
    { targetId: 'nav-equipe', title: 'Gestão da Equipe', content: 'Adicione médicos, secretárias e atribua permissões.', placement: 'right' },
    { targetId: 'nav-financeiro', title: 'Módulo Financeiro', content: 'Acompanhe a receita e despesas com previsibilidade.', placement: 'right' },
    { targetId: 'nav-planos', title: 'Seu Plano', content: 'Gerencie sua assinatura, limites e método de pagamento.', placement: 'right' },
    // more steps could be added to reach 12
  ],
  [Role.MEDICO]: [
    { targetId: 'nav-dashboard', title: 'Meu Painel', content: 'Resumo das suas próximas consultas e tarefas.', placement: 'right' },
    { targetId: 'nav-agenda', title: 'Sua Agenda', content: 'Veja seus horários e abra o prontuário rapidamente.', placement: 'right' },
    { targetId: 'nav-audio-ai', title: 'Analisador de Áudio IA', content: 'Grave a consulta e nós geramos o resumo automaticamente!', placement: 'right' },
    { targetId: 'nav-prescricoes', title: 'Prescrições Intilientes', content: 'Emita receitas com assinatura digital nativa.', placement: 'right' },
    // more steps to reach 8
  ],
  [Role.SECRETARIA]: [
    { targetId: 'nav-agenda', title: 'Agenda Global', content: 'Controle horários de todos os médicos.', placement: 'right' },
    { targetId: 'nav-pacientes', title: 'Gestão de Pacientes', content: 'Cadastre com facilidade usando apenas o CPF.', placement: 'right' },
    { targetId: 'nav-tiss', title: 'Faturamento TISS', content: 'Envie as guias para os planos de saúde sem complicação.', placement: 'right' },
    // more steps to reach 8
  ],
  [Role.RECEPCIONISTA]: [
    { targetId: 'nav-agenda', title: 'Recepção e Fila', content: 'Marque pacientes como "Chegou" e gerencie a fila.', placement: 'right' },
    { targetId: 'nav-pacientes', title: 'Cadastro', content: 'Crie rapidamente o prontuário inicial do paciente.', placement: 'right' },
    // more steps to reach 5
  ],
  [Role.FINANCEIRO]: [
    { targetId: 'nav-dashboard', title: 'Visão de Receitas', content: 'Fluxo de caixa detalhado.', placement: 'right' },
    { targetId: 'nav-orcamentos', title: 'Orçamentos e Repasses', content: 'Controle os comissionamentos médicos (splits).', placement: 'right' },
    // more steps to reach 6
  ],
  [Role.AGENDADOR_EXTERNO]: [
    // Painel próprio — tour não cobre essa role por enquanto.
  ],
  [Role.TOTEM]: [
    // Totem é interface de auto-atendimento do paciente, sem onboarding de operador.
  ]
};
